import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import Apis from '../Apis';

const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });
const fmt     = (v) => parseFloat(v || 0).toFixed(2);
const fmtDate = (s) => (s ? String(s).split('-').reverse().join('/') : '—');

function resolveLogoSrc(empresaData) {
  const candidates = [
    localStorage.getItem('imagemLogin'),
    empresaData?.logo,
    empresaData?.imagem,
    empresaData?.foto,
  ];
  for (const raw of candidates) {
    if (!raw || raw === 'null' || raw === 'undefined') continue;
    const c = String(raw).replace(/"/g, '').trim();
    if (!c) continue;
    if (c.startsWith('data:') || c.startsWith('http')) return c;
    if (c.length > 100) return `data:image/jpeg;base64,${c}`;
  }
  return '';
}

function gerarHtml({ pedido, empresa, cliente, vendedor, formaPagamento, logo }) {
  const now  = new Date();
  const pad  = (n) => String(n).padStart(2, '0');
  const hora = `${now.getHours()}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
  const data = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()}`;

  const qtdParcelas  = pedido.parcelas?.length || 0;
  const parcelasHtml = (pedido.parcelas || []).map(p =>
    `<p class="parc">Parc. ${p.parcela} - Vencimento: ${fmtDate(p.vencimento)} - R$ ${fmt(p.valor)}</p>`
  ).join('');

  let totalDesconto = 0;
  (pedido.produtos || []).forEach(p => { totalDesconto += parseFloat(p.desconto || 0); });
  const subtotal = parseFloat(pedido.valor || 0);
  const total    = (subtotal - totalDesconto).toFixed(2);

  const produtosHtml = (pedido.produtos || []).map((p, i) => `
    <tr style="background-color:${i % 2 !== 0 ? '#f5f5f5' : '#fff'}">
      <td class="l">${p.descricao || ''}</td>
      <td>${p.unidade || ''}</td>
      <td class="r">${fmt(p.qt)}</td>
      <td class="r">${fmt(p.preco)}</td>
      <td class="r">${(parseFloat(p.qt || 0) * parseFloat(p.preco || 0)).toFixed(2)}</td>
      <td class="r">${fmt(p.desconto)}</td>
    </tr>`).join('');

  const clienteNome   = pedido.participante?.nome || '';
  const clienteCodigo = pedido.participante?.id   || '';
  const clienteCnpj   = cliente?.cnpj_cpf || '';
  const fantasia      = cliente?.apelido  || 'NÃO INFORMADO';
  const contato       = cliente?.fone1    || 'NÃO INFORMADO';
  const endCliente    = [
    cliente?.cidade, cliente?.uf, cliente?.logradouro,
    cliente?.numero, cliente?.bairro, cliente?.cep,
  ].filter(Boolean).join(' - ');

  const tipoLabel = String(pedido.ident_operacao) === '2' ? 'TROCA' : 'VENDA';
  const condPagto = formaPagamento
    ? `${formaPagamento} ${qtdParcelas} PARCELA${qtdParcelas > 1 ? 'S' : ''}`
    : '';

  const logoTag = logo ? `<img src="${logo}" class="img-header" />` : '';

  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <style>
    @page { size: A4; margin: 0; }
    * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    body { padding: 1.5cm 2cm; font-family: Helvetica, Arial, sans-serif; }
    .header { display: flex; align-items: center; width: 100%; column-gap: 20px; }
    .img-header { width: 150px; height: 150px; object-fit: contain; }
    .topo { text-align: left; }
    .nome-empresa { font-size: 20px; font-weight: bold; margin: 0 0 3px; text-transform: uppercase; }
    .topo p { font-size: 15px; margin: 3px 0; }
    hr.div { margin: 20px 0; border: none; border-top: 1px solid #ccc; }
    h2 { text-align: center; font-size: 22px; margin: 16px 0; }
    .dd-pedido { display: flex; justify-content: space-between; margin-bottom: 10px; }
    .dd-pedido p { font-size: 20px; font-weight: bold; margin: 0 0 3px; }
    .right { text-align: right; }
    .cli { font-size: 15px; margin: 3px 0; text-align: left; }
    .vend p { font-size: 15px; margin: 3px 0; text-align: left; }
    .parc { font-size: 15px; font-weight: bold; margin: 3px 0; text-align: left; }
    table { border-collapse: collapse; width: 100%; }
    thead { background-color: #ebebeb; border-top: 2px dashed #888; border-bottom: 2px dashed #888; }
    th, td { font-size: 15px; padding: 6px 8px; text-align: center; }
    th.l, td.l { text-align: left; }
    th.r, td.r { text-align: right; }
    tbody tr { page-break-inside: avoid; }
    .rodape { page-break-inside: avoid; text-align: left; margin-top: 15px; }
    .rodape .lin { display: flex; justify-content: space-between; }
    .rodape .lin p { font-size: 20px; font-weight: bold; margin: 3px 0; }
    .nao-recibo { font-size: 20px; font-weight: bold; margin: 10px 0 3px; }
    .dt { font-size: 14px; font-weight: bold; }
  </style>
</head>
<body>

  <div class="header">
    ${logoTag}
    <div class="topo">
      <p class="nome-empresa">${empresa?.nome || ''}</p>
      <p>CNPJ: ${empresa?.cnpj || ''}</p>
      <p>${[empresa?.logradouro, empresa?.numero, empresa?.bairro].filter(Boolean).join(', ')}</p>
      <p>${empresa?.cidade || ''}${empresa?.uf ? ' - ' + empresa.uf : ''}${empresa?.cep ? ' - CEP: ' + empresa.cep : ''}</p>
      <p>${[empresa?.telefone ? 'Telefone: ' + empresa.telefone : '', empresa?.email ? 'email: ' + empresa.email : ''].filter(Boolean).join(' - ')}</p>
    </div>
  </div>

  <hr class="div" />
  <h2>COMPROVANTE DE ${tipoLabel}</h2>

  <div class="dd-pedido">
    <p>${pedido.numero ? 'PEDIDO: ' + pedido.numero : ''}</p>
    <p class="right">DATA: ${fmtDate(pedido.data)}<br/>FATURAMENTO: ${fmtDate(pedido.data_saida || pedido.data)}</p>
  </div>

  <p class="cli">CLIENTE: ${clienteCodigo ? clienteCodigo + ' - ' : ''}${clienteNome}${clienteCnpj ? ' (' + clienteCnpj + ')' : ''}</p>
  <p class="cli">FANTASIA: ${fantasia}</p>
  <p class="cli">CONTATO: ${contato}</p>
  ${endCliente ? `<p class="cli">${endCliente}</p>` : ''}

  <hr class="div" />

  <div class="vend">
    ${vendedor  ? `<p>VENDEDOR: ${vendedor}</p>` : ''}
    ${condPagto ? `<p>CONDIÇÕES DE PAGAMENTO: ${condPagto}</p>` : ''}
    ${parcelasHtml}
  </div>

  <hr class="div" />

  <table>
    <thead>
      <tr>
        <th class="l">Descrição</th>
        <th>Unid.</th>
        <th class="r">Quantidade</th>
        <th class="r">Preço</th>
        <th class="r">Total</th>
        <th class="r">Desconto</th>
      </tr>
    </thead>
    <tbody>${produtosHtml}</tbody>
  </table>

  <div class="rodape">
    <hr style="margin:0 0 10px;border:none;border-top:1px solid #000;" />
    <div class="lin"><p>Subtotal</p><p>R$ ${fmt(subtotal)}</p></div>
    <div class="lin"><p>Desconto</p><p>R$ ${totalDesconto.toFixed(2)}</p></div>
    <div class="lin"><p>Total</p><p>R$ ${total}</p></div>
    <p class="nao-recibo">Não vale como recibo</p>
    <p class="dt">${data} ${hora}</p>
  </div>

  <script>
    window.onload = function() {
      window.print();
      window.onafterprint = function() { window.close(); };
    };
  </script>
</body>
</html>`;
}

export default function Comprovante({ pedidoId, onClose }) {
  useEffect(() => {
    const h = headers();
    Promise.all([
      fetch(Apis.urlListarOnePedidos,  { method: 'PUT',  headers: h, body: JSON.stringify({ id: pedidoId }) }).then(r => r.json()),
      fetch(Apis.urlListarOneEmpresas, { method: 'POST', headers: h, body: JSON.stringify({ id: localStorage.getItem('id') }) }).then(r => r.json()),
    ]).then(([pedRes, empRes]) => {
      const p = pedRes.registros?.[0];
      const e = empRes.registros?.[0];

      let cliente = null, vendedor = '', formaPagamento = '';
      const extras = [];

      if (p?.participante?.id) {
        extras.push(
          fetch(Apis.urlListarOneClientes, { method: 'POST', headers: h, body: JSON.stringify({ id: p.participante.id }) })
            .then(r => r.json()).then(res => { cliente = res.registros?.[0] || null; }).catch(() => {})
        );
      }
      if (p?.vendedor_id) {
        extras.push(
          fetch(Apis.urlListarOneRepresentantes, { method: 'POST', headers: h, body: JSON.stringify({ id: p.vendedor_id }) })
            .then(r => r.json()).then(res => { vendedor = res.registros?.[0]?.nome || ''; }).catch(() => {})
        );
      }
      if (p?.forma_pagamento_id) {
        extras.push(
          fetch(Apis.urlListarOneFormaPagamento, { method: 'POST', headers: h, body: JSON.stringify({ id: p.forma_pagamento_id }) })
            .then(r => r.json()).then(res => { formaPagamento = res.registros?.[0]?.descricao || ''; }).catch(() => {})
        );
      }

      Promise.all(extras).then(() => {
        const logo = resolveLogoSrc(e);
        const html = gerarHtml({ pedido: p, empresa: e, cliente, vendedor, formaPagamento, logo });
        const win  = window.open('', '_blank', 'width=900,height=700');
        win.document.write(html);
        win.document.close();
        onClose();
      });
    }).catch(() => onClose());
  }, []); // eslint-disable-line

  return ReactDOM.createPortal(
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.35)', backdropFilter: 'blur(2px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'AlteHaasGroteskRegular','Segoe UI',sans-serif",
    }}>
      <div style={{
        background: '#fff', padding: '20px 32px', borderRadius: 8,
        fontSize: 14, color: '#374151',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
      }}>
        Gerando comprovante…
      </div>
    </div>,
    document.body
  );
}
